import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            applicationInitialized: 'e/pages/isInitialized',
            userInitialized: 'e/users/userInitialized',
        }),
    },
    methods: {
        ...mapActions({
            setApplicationInitialized: 'e/pages/setInitialized',
            setUserInitialized: 'e/users/setUserInitialized',
        }),
    },
}
